import { User } from "@segment/analytics-next";
import { useEffect, useState } from "react";
import { useUser } from "@/auth/useUser";
import { useAnalytics } from "@/components/common/segment/AnalyticsContext";

export const useUserAnalyticsId = () => {
  const analytics = useAnalytics();
  const [analyticsUser, setAnalyticsUser] = useState<User | null>(null);

  useEffect(() => {
    analytics?.user().then((user) => setAnalyticsUser(user));
  }, [analytics]);

  const { user } = useUser();

  // If we have an authenticated user, return their ID
  if (user?.id) {
    return user.id;
  }

  // Otherwise, get the anonymous ID from Segment
  return analyticsUser?.anonymousId();
};
